export default "__VITE_ASSET__6b1ed423__"